module.exports = __webpack_public_path__ + "56ea20387a5f3d0bbaf8d6123e3d0f08.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared.html
// module id = 2543
// module chunks = 0